"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeArgs = exports.getRandomBN = void 0;
const bn_js_1 = __importDefault(require("bn.js"));
function getRandomBN(bits) {
    const byteLength = Math.ceil(bits / 8);
    const randomBytes = crypto.getRandomValues(new Uint8Array(byteLength));
    return new bn_js_1.default(randomBytes);
}
exports.getRandomBN = getRandomBN;
function serializeArgs(args = {}) {
    const jsonString = JSON.stringify(args);
    const encoder = new TextEncoder();
    const binaryData = encoder.encode(jsonString);
    return Buffer.from(binaryData.buffer, binaryData.byteOffset, binaryData.byteLength);
}
exports.serializeArgs = serializeArgs;
